/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_PolicyInputs */

const en_cc_policy = /** @type {(inputs: Cc_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose and review the meeting first. The extension never presses Save, sends invitations, reads Calendar event titles, or stores login tokens.`)
};

const id_cc_policy = /** @type {(inputs: Cc_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda memilih dan meninjau meeting lebih dahulu. Ekstensi tidak menekan Simpan, mengirim undangan, membaca judul acara Calendar, atau menyimpan token login.`)
};

/**
* | output |
* | --- |
* | "Choose and review the meeting first. The extension never presses Save, sends invitations, reads Calendar event titles, or stores login tokens." |
*
* @param {Cc_PolicyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_policy = /** @type {((inputs?: Cc_PolicyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_PolicyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_policy(inputs)
	return en_cc_policy(inputs)
});